import React from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';

import './InputRow.css';


const styles = {
  maskedInput: {
    width: '140px',
    height: '45px',
    fontSize: '22px',
    color: '#767676',
    border: '1px solid #4a87c0',
    borderRadius: '2px',
    textAlign: 'right',
    margin: '10px 0',
    paddingRight: '12px',
  },
};

export const getInput = ({
  placeholder,
  value = 0,
  onChange,
  mask,
  ...props
}) => {
  if (mask) {
    return (
      <MaskedInput
        style={styles.maskedInput}
        key={`maskedInputField-${placeholder}`}
        mask={mask}
        guide={false}
        maxLength={20}
        onChange={onChange}
        value={value}
        {...props}
      />
    );
  }
  return (
    <input
      styleName="inputBox"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
    />
  );
};

const Component = props => (
  <div styleName="inputRow">
    <div styleName="label">
      { props.label }
    </div>
    { getInput(props) }
  </div>
);

Component.propTypes = {
  label: PropTypes.string.isRequired,
};

Component.displayName = 'InputRow';

export default Component;



// WEBPACK FOOTER //
// ./src/components/ExternalInvest/components/InputRow.js